// /**
//  * mobile-slider.js  —  v3
//  * Transform-based infinite slider for Shopify Dawn theme (mobile only).
//  *
//  * Strategy: instead of relying on native scroll-snap (where the browser
//  * controls momentum and clone-jumps race against it), we:
//  *   1. Wrap all real slides in a single <div class="ms-track"> inside a
//  *      <div class="ms-viewport"> and move it with CSS transform: translateX().
//  *   2. Prepend a clone of the LAST slide and append a clone of the FIRST
//  *      slide — the classic infinite-loop trick.
//  *   3. Handle ALL touch ourselves (touchstart / touchmove / touchend).
//  *      The browser never gets a chance to do free-running momentum, so
//  *      there is zero "fast scroll across all slides" glitch.
//  *   4. On touchend we animate to the adjacent slide (or clone), then on
//  *      transitionend we do an *instant* (no-transition) jump to the matching
//  *      real slide — completely invisible because the clone and real slide
//  *      look identical and sit at the same visual position.
//  */

// (function () {
//   'use strict';

//   const MOBILE_BREAKPOINT = 750;   // must match CSS media query
//   const DOT_THRESHOLD     = 6;     // use dots below this count, progress bar above
//   const SWIPE_THRESHOLD   = 40;    // px — minimum drag to commit as a swipe
//   const TRANSITION_MS     = 320;   // slide animation duration in ms

//   function isMobile() {
//     return window.innerWidth < MOBILE_BREAKPOINT;
//   }

//   // ─────────────────────────────────────────────────────────────────────────────

//   class MobileSlider {
//     constructor(hostList) {
//       this.hostList        = hostList;  // Dawn's <ul class="product__media-list">
//       this.totalReal       = 0;
//       this.current         = 0;         // current real index (0-based)
//       this.trackEl         = null;
//       this.viewportEl      = null;
//       this.allSlides       = [];        // [clone-last, real-0 … real-n, clone-first]
//       this.slideWidth      = 0;
//       this.dragging        = false;
//       this.startX          = 0;
//       this.currentX        = 0;        // live translateX during drag
//       this.baseX           = 0;        // translateX at touchstart
//       this.animating       = false;
//       this.dots            = null;
//       this.progressFill    = null;
//       this.counter         = null;

//       this._build();
//     }

//     // ── DOM construction ──────────────────────────────────────────────────────

//     _build() {
//       const items = Array.from(
//         this.hostList.querySelectorAll(':scope > .product__media-item')
//       );
//       this.totalReal = items.length;
//       if (this.totalReal < 2) return;

//       // Viewport (overflow:hidden window)
//       const viewport = document.createElement('div');
//       viewport.className = 'ms-viewport';
//       this.viewportEl = viewport;

//       // Track (the moving strip — contains clone-last + reals + clone-first)
//       const track = document.createElement('div');
//       track.className = 'ms-track';
//       this.trackEl = track;

//       const cloneLast  = items[this.totalReal - 1].cloneNode(true);
//       const cloneFirst = items[0].cloneNode(true);
//       [cloneLast, cloneFirst].forEach(c => {
//         c.setAttribute('aria-hidden', 'true');
//         c.classList.add('ms-clone');
//       });

//       track.appendChild(cloneLast);
//       items.forEach(item => track.appendChild(item));
//       track.appendChild(cloneFirst);

//       viewport.appendChild(track);

//       // Insert our viewport before Dawn's list, then hide the list
//       this.hostList.insertAdjacentElement('beforebegin', viewport);
//       this.hostList.style.display = 'none';

//       this.allSlides = Array.from(
//         track.querySelectorAll(':scope > .product__media-item')
//       );
//       // allSlides[0]             = clone of last
//       // allSlides[1..totalReal]  = real slides
//       // allSlides[totalReal + 1] = clone of first

//       this._measure();
//       this._goTo(0, false);
//       this._buildIndicator();
//       this._buildCounter();
//       this._bindTouch();
//       this._bindResize();
//       this._swipeHint();
//     }

//     // ── Geometry ──────────────────────────────────────────────────────────────

//     _measure() {
//       this.slideWidth = this.viewportEl.offsetWidth;
//       const totalWidth = this.allSlides.length * this.slideWidth;
//       this.trackEl.style.width = totalWidth + 'px';
//       this.allSlides.forEach(s => { s.style.width = this.slideWidth + 'px'; });
//       // Re-snap to current slide after resize (no animation)
//       this._applyTranslate(this._xFor(this.current), false);
//       this.baseX = this._xFor(this.current);
//     }

//     // translateX that puts real slide `realIdx` in the viewport.
//     // realIdx+1 because allSlides[0] is clone-of-last.
//     _xFor(realIdx) {
//       return -((realIdx + 1) * this.slideWidth);
//     }

//     // ── Apply transform ───────────────────────────────────────────────────────

//     _applyTranslate(x, animate) {
//       this.currentX = x;
//       this.trackEl.style.transition = animate
//         ? `transform ${TRANSITION_MS}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`
//         : 'none';
//       this.trackEl.style.transform = `translateX(${x}px)`;
//     }

//     // ── Navigate ──────────────────────────────────────────────────────────────

//     // Go directly to a real slide (wraps automatically).
//     _goTo(realIdx, animate = true) {
//       this.current = ((realIdx % this.totalReal) + this.totalReal) % this.totalReal;
//       const x = this._xFor(this.current);
//       this._applyTranslate(x, animate);
//       this.baseX = x;
//       this._updateUI();
//     }

//     // Navigate one step: may land on a clone, which is fine —
//     // transitionend will invisibly jump to the real counterpart.
//     _goToWithWrap(targetReal) {
//       this.animating = true;

//       if (targetReal < 0) {
//         // Swipe right past slide 0 → animate to clone-of-last (allSlides[0])
//         const x = 0; // clone-of-last is at position 0
//         this._applyTranslate(x, true);
//         this.baseX   = x;
//         this.current = this.totalReal - 1; // UI shows last real slide
//       } else if (targetReal >= this.totalReal) {
//         // Swipe left past last slide → animate to clone-of-first
//         const x = -((this.totalReal + 1) * this.slideWidth);
//         this._applyTranslate(x, true);
//         this.baseX   = x;
//         this.current = 0; // UI shows first real slide
//       } else {
//         this._goTo(targetReal, true);
//       }

//       this._updateUI();
//     }

//     // After transition: if we're sitting on a clone, silently jump to the real slide.
//     _handleInfiniteJump() {
//       const cloneLastX  = 0;
//       const cloneFirstX = -((this.totalReal + 1) * this.slideWidth);

//       if (this.currentX >= -this.slideWidth / 2) {
//         // On or past clone-of-last → jump to real last
//         this._applyTranslate(this._xFor(this.totalReal - 1), false);
//         this.baseX = this._xFor(this.totalReal - 1);
//       } else if (this.currentX <= cloneFirstX + this.slideWidth / 2) {
//         // On or past clone-of-first → jump to real first
//         this._applyTranslate(this._xFor(0), false);
//         this.baseX = this._xFor(0);
//       }

//       this.animating = false;
//     }

//     // ── Touch ─────────────────────────────────────────────────────────────────

//     _bindTouch() {
//       const el = this.viewportEl;

//       el.addEventListener('touchstart', (e) => {
//         if (this.animating) {
//           // Interrupt ongoing transition: freeze track where it is
//           const style    = window.getComputedStyle(this.trackEl);
//           const matrix   = new DOMMatrix(style.transform);
//           this.baseX     = matrix.m41;
//           this.currentX  = this.baseX;
//           this.animating = false;
//         }
//         this.dragging = true;
//         this.startX   = e.touches[0].clientX;
//         this.trackEl.style.transition = 'none';
//       }, { passive: true });

//       el.addEventListener('touchmove', (e) => {
//         if (!this.dragging) return;
//         const delta = e.touches[0].clientX - this.startX;
//         this._applyTranslate(this.baseX + delta, false);
//       }, { passive: true });

//       el.addEventListener('touchend', (e) => {
//         if (!this.dragging) return;
//         this.dragging = false;
//         const delta = e.changedTouches[0].clientX - this.startX;

//         if (Math.abs(delta) >= SWIPE_THRESHOLD) {
//           this._goToWithWrap(delta < 0 ? this.current + 1 : this.current - 1);
//         } else {
//           // Not far enough — snap back
//           this._goTo(this.current, true);
//           this.animating = true;
//         }
//       }, { passive: true });

//       this.trackEl.addEventListener('transitionend', () => {
//         this._handleInfiniteJump();
//       });
//     }

//     // ── Indicators ────────────────────────────────────────────────────────────

//     _buildIndicator() {
//       const wrapper = document.createElement('div');

//       if (this.totalReal <= DOT_THRESHOLD) {
//         wrapper.className = 'mobile-slider-bar';
//         this.dots = [];
//         for (let i = 0; i < this.totalReal; i++) {
//           const dot = document.createElement('span');
//           dot.className = 'mobile-slider-dot';
//           dot.setAttribute('role', 'button');
//           dot.setAttribute('tabindex', '0');
//           dot.setAttribute('aria-label', `Go to image ${i + 1}`);
//           dot.addEventListener('click',   () => this._goTo(i));
//           dot.addEventListener('keydown', (e) => {
//             if (e.key === 'Enter' || e.key === ' ') this._goTo(i);
//           });
//           wrapper.appendChild(dot);
//           this.dots.push(dot);
//         }
//       } else {
//         wrapper.className = 'mobile-slider-progress';
//         const fill = document.createElement('div');
//         fill.className = 'mobile-slider-progress__fill';
//         wrapper.appendChild(fill);
//         this.progressFill = fill;
//       }

//       this.viewportEl.insertAdjacentElement('afterend', wrapper);
//     }

//     _buildCounter() {
//       const counter = document.createElement('span');
//       counter.className = 'mobile-slider-counter';
//       counter.setAttribute('aria-live', 'polite');
//       counter.setAttribute('aria-atomic', 'true');
//       this.viewportEl.appendChild(counter);
//       this.counter = counter;
//       this._updateUI();
//     }

//     _updateUI() {
//       if (this.counter) {
//         this.counter.textContent = `${this.current + 1} / ${this.totalReal}`;
//       }
//       if (this.dots) {
//         this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
//       } else if (this.progressFill) {
//         const pct = this.totalReal > 1
//           ? (this.current / (this.totalReal - 1)) * 100
//           : 0;
//         this.progressFill.style.width = `${pct}%`;
//       }
//     }

//     // ── Resize ────────────────────────────────────────────────────────────────

//     _bindResize() {
//       let timer;
//       window.addEventListener('resize', () => {
//         clearTimeout(timer);
//         timer = setTimeout(() => this._measure(), 200);
//       });
//     }

//     // ── Swipe hint ────────────────────────────────────────────────────────────

//     _swipeHint() {
//       if (sessionStorage.getItem('mobileSliderHintSeen')) return;
//       this.trackEl.classList.add('do-swipe-hint');
//       this.trackEl.addEventListener('animationend', () => {
//         this.trackEl.classList.remove('do-swipe-hint');
//         sessionStorage.setItem('mobileSliderHintSeen', '1');
//       }, { once: true });
//     }
//   }

//   // ── Bootstrap ────────────────────────────────────────────────────────────────

//   function initAllSliders() {
//     if (!isMobile()) return;
//     document.querySelectorAll('.product__media-list').forEach((list) => {
//       if (list.dataset.msInit) return;
//       list.dataset.msInit = '1';
//       new MobileSlider(list);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initAllSliders);
//   } else {
//     initAllSliders();
//   }

//   document.addEventListener('shopify:section:load', () => {
//     document.querySelectorAll('[data-ms-init]').forEach(el => delete el.dataset.msInit);
//     initAllSliders();
//   });

// })();


/**
 * mobile-slider.js  —  v3
 * Transform-based infinite slider for Shopify Dawn theme (mobile only).
 *
 * Strategy: instead of relying on native scroll-snap (where the browser
 * controls momentum and clone-jumps race against it), we:
 *   1. Wrap all real slides in a single <div class="ms-track"> inside a
 *      <div class="ms-viewport"> and move it with CSS transform: translateX().
 *   2. Prepend a clone of the LAST slide and append a clone of the FIRST
 *      slide — the classic infinite-loop trick.
 *   3. Handle ALL touch ourselves (touchstart / touchmove / touchend).
 *      The browser never gets a chance to do free-running momentum, so
 *      there is zero "fast scroll across all slides" glitch.
 *   4. On touchend we animate to the adjacent slide (or clone), then on
 *      transitionend we do an *instant* (no-transition) jump to the matching
 *      real slide — completely invisible because the clone and real slide
 *      look identical and sit at the same visual position.
 */


/**
 * mobile-slider.js  —  v4
 * Transform-based infinite slider for Shopify Dawn theme (mobile only).
 * Includes draggable scrollbar below the slider as a navigation toggle.
 */

(function () {
  'use strict';

  const MOBILE_BREAKPOINT = 750;
  const DOT_THRESHOLD     = 6;
  const SWIPE_THRESHOLD   = 40;
  const TRANSITION_MS     = 320;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  class MobileSlider {
    constructor(hostList) {
      this.hostList     = hostList;
      this.totalReal    = 0;
      this.current      = 0;
      this.trackEl      = null;
      this.viewportEl   = null;
      this.allSlides    = [];
      this.slideWidth   = 0;
      this.dragging     = false;
      this.startX       = 0;
      this.currentX     = 0;
      this.baseX        = 0;
      this.animating    = false;
      this.dots         = null;
      this.bar          = null;
      this.progressFill = null;
      this.counter      = null;
      this.scrollbarTrack = null;
      this.scrollbarThumb = null;

      this._build();
    }

    // ── DOM construction ──────────────────────────────────────────────────────

    _build() {
      const items = Array.from(
        this.hostList.querySelectorAll(':scope > .product__media-item')
      );
      this.totalReal = items.length;
      if (this.totalReal < 2) return;

      const viewport = document.createElement('div');
      viewport.className = 'ms-viewport';
      this.viewportEl = viewport;

      const track = document.createElement('div');
      track.className = 'ms-track';
      this.trackEl = track;

      const cloneLast  = items[this.totalReal - 1].cloneNode(true);
      const cloneFirst = items[0].cloneNode(true);
      [cloneLast, cloneFirst].forEach(c => {
        c.setAttribute('aria-hidden', 'true');
        c.classList.add('ms-clone');
      });

      track.appendChild(cloneLast);
      items.forEach(item => track.appendChild(item));
      track.appendChild(cloneFirst);

      viewport.appendChild(track);

      // Insert into DOM FIRST so offsetWidth is available
      this.hostList.insertAdjacentElement('beforebegin', viewport);
      this.hostList.style.display = 'none';

      this.allSlides = Array.from(
        track.querySelectorAll(':scope > .product__media-item')
      );

      // Defer one rAF so the browser finishes layout before we read offsetWidth
      requestAnimationFrame(() => {
        this._measure();
        if (this.slideWidth > 0) {
          this._initAfterMeasure();
        } else {
          const observer = new ResizeObserver((entries) => {
            for (let entry of entries) {
              if (entry.contentRect.width > 0) {
                this._measure();
                this._initAfterMeasure();
                observer.disconnect();
                break;
              }
            }
          });
          observer.observe(this.viewportEl);
        }
      });
    }

    _initAfterMeasure() {
      this._goTo(0, false);
      this._buildIndicator();
      this._buildCounter();
      this._buildScrollbar();
      this._bindTouch();
      this._bindResize();
      this._bindActiveObserver();
      this._swipeHint();
    }

    // ── Geometry ──────────────────────────────────────────────────────────────

    _measure() {
      this.slideWidth = this.viewportEl.offsetWidth;
      if (!this.slideWidth) return; // guard against 0 (hidden page)
      this.trackEl.style.width = (this.allSlides.length * this.slideWidth) + 'px';
      this.allSlides.forEach(s => { s.style.width = this.slideWidth + 'px'; });
      this._applyTranslate(this._xFor(this.current), false);
      this.baseX = this._xFor(this.current);
    }

    _xFor(realIdx) {
      return -((realIdx + 1) * this.slideWidth);
    }

    // ── Apply transform ───────────────────────────────────────────────────────

    _applyTranslate(x, animate) {
      this.currentX = x;
      this.trackEl.style.transition = animate
        ? `transform ${TRANSITION_MS}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`
        : 'none';
      this.trackEl.style.transform = `translateX(${x}px)`;
    }

    // ── Navigate ──────────────────────────────────────────────────────────────

    _goTo(realIdx, animate = true) {
      this.current = ((realIdx % this.totalReal) + this.totalReal) % this.totalReal;
      const x = this._xFor(this.current);
      this._applyTranslate(x, animate);
      this.baseX = x;
      this._updateUI();
    }

    _goToWithWrap(targetReal) {
      this.animating = true;

      if (targetReal < 0) {
        const x = 0;
        this._applyTranslate(x, true);
        this.baseX   = x;
        this.current = this.totalReal - 1;
      } else if (targetReal >= this.totalReal) {
        const x = -((this.totalReal + 1) * this.slideWidth);
        this._applyTranslate(x, true);
        this.baseX   = x;
        this.current = 0;
      } else {
        this._goTo(targetReal, true);
      }

      this._updateUI();
    }

    _handleInfiniteJump() {
      const cloneFirstX = -((this.totalReal + 1) * this.slideWidth);

      if (this.currentX >= -this.slideWidth / 2) {
        this._applyTranslate(this._xFor(this.totalReal - 1), false);
        this.baseX = this._xFor(this.totalReal - 1);
      } else if (this.currentX <= cloneFirstX + this.slideWidth / 2) {
        this._applyTranslate(this._xFor(0), false);
        this.baseX = this._xFor(0);
      }

      this.animating = false;
    }

    // ── Touch ─────────────────────────────────────────────────────────────────

    _bindTouch() {
      const el = this.viewportEl;

      el.addEventListener('touchstart', (e) => {
        if (this.animating) {
          const matrix = new DOMMatrix(window.getComputedStyle(this.trackEl).transform);
          this.baseX    = matrix.m41;
          this.currentX = this.baseX;
          this.animating = false;
        }
        this.dragging = true;
        this.startX   = e.touches[0].clientX;
        this.trackEl.style.transition = 'none';
      }, { passive: true });

      el.addEventListener('touchmove', (e) => {
        if (!this.dragging) return;
        const delta = e.touches[0].clientX - this.startX;
        this._applyTranslate(this.baseX + delta, false);
      }, { passive: true });

      el.addEventListener('touchend', (e) => {
        if (!this.dragging) return;
        this.dragging = false;
        const delta = e.changedTouches[0].clientX - this.startX;

        if (Math.abs(delta) >= SWIPE_THRESHOLD) {
          this._goToWithWrap(delta < 0 ? this.current + 1 : this.current - 1);
        } else {
          this._goTo(this.current, true);
          this.animating = true;
        }
      }, { passive: true });

      this.trackEl.addEventListener('transitionend', () => {
        this._handleInfiniteJump();
      });
    }

    // ── Indicators ────────────────────────────────────────────────────────────

    _buildIndicator() {
      const wrapper = document.createElement('div');

      if (this.totalReal <= DOT_THRESHOLD) {
        wrapper.className = 'mobile-slider-bar';
        this.dots = [];
        for (let i = 0; i < this.totalReal; i++) {
          const dot = document.createElement('span');
          dot.className = 'mobile-slider-dot';
          dot.setAttribute('role', 'button');
          dot.setAttribute('tabindex', '0');
          dot.setAttribute('aria-label', `Go to image ${i + 1}`);
          dot.addEventListener('click',   () => this._goTo(i));
          dot.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') this._goTo(i);
          });
          wrapper.appendChild(dot);
          this.dots.push(dot);
        }
      } else {
        wrapper.className = 'mobile-slider-progress';
        const fill = document.createElement('div');
        fill.className = 'mobile-slider-progress__fill';
        wrapper.appendChild(fill);
        this.progressFill = fill;
      }

      this.viewportEl.insertAdjacentElement('afterend', wrapper);
      this.bar = wrapper;
    }

    // ── Counter ───────────────────────────────────────────────────────────────

    _buildCounter() {
      const counter = document.createElement('span');
      counter.className = 'mobile-slider-counter';
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      this.viewportEl.appendChild(counter);
      this.counter = counter;
    }

    // ── Scrollbar ─────────────────────────────────────────────────────────────

    _buildScrollbar() {
      const track = document.createElement('div');
      track.className = 'ms-scrollbar';
      track.setAttribute('role', 'slider');
      track.setAttribute('aria-label', 'Image slider');
      track.setAttribute('aria-valuemin', '1');
      track.setAttribute('aria-valuemax', String(this.totalReal));
      track.setAttribute('aria-valuenow', '1');
      track.setAttribute('tabindex', '0');

      const thumb = document.createElement('div');
      thumb.className = 'ms-scrollbar__thumb';
      track.appendChild(thumb);

      this.scrollbarTrack = track;
      this.scrollbarThumb = thumb;

      // Place scrollbar after the indicator bar (dots or progress)
      const anchor = this.bar || this.viewportEl;
      anchor.insertAdjacentElement('afterend', track);

      this._updateScrollbar();
      this._bindScrollbarDrag();
      this._bindScrollbarKeys();
    }

    _updateScrollbar() {
      if (!this.scrollbarTrack) return;
      const thumbPct = (1 / this.totalReal) * 100;
      const leftPct  = (this.current / this.totalReal) * 100;
      this.scrollbarThumb.style.width = `${thumbPct}%`;
      this.scrollbarThumb.style.left  = `${leftPct}%`;
      this.scrollbarTrack.setAttribute('aria-valuenow', String(this.current + 1));
    }

    _bindScrollbarDrag() {
      const thumb = this.scrollbarThumb;
      const track = this.scrollbarTrack;
      let sbDragging    = false;
      let sbStartOffset = 0;

      const onMove = (clientX) => {
        if (!sbDragging) return;
        const trackRect = track.getBoundingClientRect();
        const thumbW    = thumb.offsetWidth;
        const maxLeft   = trackRect.width - thumbW;
        const rawLeft   = (clientX - trackRect.left) - sbStartOffset;
        const clamped   = Math.max(0, Math.min(rawLeft, maxLeft));

        thumb.style.transition = 'none';
        thumb.style.left = `${(clamped / trackRect.width) * 100}%`;

        const ratio    = maxLeft > 0 ? clamped / maxLeft : 0;
        const newSlide = Math.round(ratio * (this.totalReal - 1));
        if (newSlide !== this.current) {
          this._goTo(newSlide, true);
        }
      };

      const onEnd = () => {
        if (!sbDragging) return;
        sbDragging = false;
        thumb.style.transition = '';
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup',   onMouseUp);
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend',  onTouchEnd);
        this._updateScrollbar();
      };

      const onMouseMove = (e) => onMove(e.clientX);
      const onMouseUp   = ()    => onEnd();
      const onTouchMove = (e) => onMove(e.touches[0].clientX);
      const onTouchEnd  = ()    => onEnd();

      const onStart = (clientX) => {
        sbDragging    = true;
        sbStartOffset = clientX - thumb.getBoundingClientRect().left;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup',   onMouseUp);
        document.addEventListener('touchmove', onTouchMove, { passive: true });
        document.addEventListener('touchend',  onTouchEnd);
      };

      thumb.addEventListener('mousedown',  (e) => { e.preventDefault(); onStart(e.clientX); });
      thumb.addEventListener('touchstart', (e) => { onStart(e.touches[0].clientX); }, { passive: true });

      // Click on track (not thumb) → jump to that slide
      track.addEventListener('click', (e) => {
        if (e.target === thumb) return;
        const rect     = track.getBoundingClientRect();
        const ratio    = (e.clientX - rect.left) / rect.width;
        const newSlide = Math.round(ratio * (this.totalReal - 1));
        this._goTo(newSlide, true);
      });
    }

    _bindScrollbarKeys() {
      this.scrollbarTrack.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          this._goToWithWrap(this.current + 1);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          this._goToWithWrap(this.current - 1);
        }
      });
    }

    // ── Update all UI elements ────────────────────────────────────────────────

    _updateUI() {
      if (this.counter) {
        this.counter.textContent = `${this.current + 1} / ${this.totalReal}`;
      }
      if (this.dots) {
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
      } else if (this.progressFill) {
        const pct = this.totalReal > 1
          ? (this.current / (this.totalReal - 1)) * 100
          : 0;
        this.progressFill.style.width = `${pct}%`;
      }
      this._updateScrollbar();

      // Sync active classes to DOM elements
      this.allSlides.forEach((slide, idx) => {
        const isCurrent = (idx === this.current + 1);
        if (isCurrent) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });

      // Dynamic Viewport Height to match active slide
      const activeSlide = this.allSlides[this.current + 1];
      if (activeSlide) {
        const innerContainer = activeSlide.querySelector('.product-media-container') || activeSlide;
        // Wait a frame to ensure DOM layout has calculated heights
        requestAnimationFrame(() => {
          const targetHeight = innerContainer.offsetHeight;
          if (targetHeight > 0) {
            this.viewportEl.style.height = targetHeight + 'px';
          }
        });
      }
    }

    // ── Resize ────────────────────────────────────────────────────────────────

    _bindResize() {
      let timer;
      window.addEventListener('resize', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this._measure(), 200);
      });
    }

    _bindActiveObserver() {
      const realSlides = this.allSlides.slice(1, this.totalReal + 1);
      
      const callback = (mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('is-active')) {
              const realIdx = realSlides.indexOf(target);
              if (realIdx !== -1 && realIdx !== this.current) {
                this.activeObserver.disconnect();
                this._goTo(realIdx, true);
                this._connectActiveObserver();
              }
            }
          }
        }
      };

      this.activeObserver = new MutationObserver(callback);
      this._connectActiveObserver();
    }

    _connectActiveObserver() {
      const realSlides = this.allSlides.slice(1, this.totalReal + 1);
      realSlides.forEach(slide => {
        this.activeObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }

    // ── Swipe hint ────────────────────────────────────────────────────────────

    _swipeHint() {
      if (sessionStorage.getItem('mobileSliderHintSeen')) return;
      this.trackEl.classList.add('do-swipe-hint');
      this.trackEl.addEventListener('animationend', () => {
        this.trackEl.classList.remove('do-swipe-hint');
        sessionStorage.setItem('mobileSliderHintSeen', '1');
      }, { once: true });
    }

    destroy() {
      if (this.activeObserver) {
        this.activeObserver.disconnect();
      }
      if (this.trackEl && this.hostList) {
        const items = Array.from(
          this.trackEl.querySelectorAll(':scope > .product__media-item:not(.ms-clone)')
        );
        items.forEach(item => {
          this.hostList.appendChild(item);
        });
      }
      if (this.viewportEl) {
        this.viewportEl.remove();
      }
      if (this.scrollbarTrack) {
        this.scrollbarTrack.remove();
      }
      if (this.bar) {
        this.bar.remove();
      }
      if (this.counter) {
        this.counter.remove();
      }
      if (this.hostList) {
        this.hostList.style.display = '';
        delete this.hostList.dataset.msInit;
      }
    }
  }

  // ── Bootstrap ────────────────────────────────────────────────────────────────

  function handleBreakpointChange() {
    const mobile = isMobile();
    const lists = document.querySelectorAll('.product__media-list');

    lists.forEach(list => {
      if (mobile) {
        if (!list.dataset.msInit) {
          list.dataset.msInit = '1';
          list.mobileSliderInstance = new MobileSlider(list);
        }
      } else {
        if (list.dataset.msInit && list.mobileSliderInstance) {
          list.mobileSliderInstance.destroy();
          delete list.mobileSliderInstance;
        }
      }
    });
  }

  window.addEventListener('resize', handleBreakpointChange);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleBreakpointChange);
  } else {
    handleBreakpointChange();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.product__media-list').forEach(list => {
      if (list.mobileSliderInstance) {
        list.mobileSliderInstance.destroy();
        delete list.mobileSliderInstance;
      }
      delete list.dataset.msInit;
    });
    handleBreakpointChange();
  });

})();